// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table.comments-report__data td:nth-child(-n+4) {\n  min-width:150px;\n}\n@media (max-width: 992px) {\n  table.comments-report__data td:nth-child(-n+4) {\n    min-width: auto;\n  }\n}", ""]);
// Exports
module.exports = exports;
